import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { Extension } from '@tiptap/core';
import { isTextSelection } from '@tiptap/react';
const isInsideList = (state)=>{
    let listNode = false;
    const { from, to } = state.selection;
    state.doc.nodesBetween(from, to, (node)=>{
        if ([
            'listItem',
            'bulletList',
            'orderedList'
        ].includes(node.type.name)) {
            listNode = true;
        }
    });
    return listNode;
};
const INDENT_SIZE = 24;
const minLevel = 0;
const maxLevel = 10;
const typesThatCanBeIndented = [
    'paragraph',
    'heading'
];
export const Indent = Extension.create({
    name: 'da-indent',
    groups: [
        'shortcuts-enabled'
    ],
    addGlobalAttributes () {
        return [
            {
                types: typesThatCanBeIndented,
                attributes: {
                    indentType: {
                        renderHTML: (attributes)=>({})
                    },
                    indentation: {
                        renderHTML: (attributes)=>{
                            if (attributes.indentation === 0 || Number.isNaN(parseInt(attributes.indentation, 10))) {
                                return {};
                            }
                            if (attributes.indentType === 'line') {
                                return {
                                    style: `text-indent: ${attributes.indentation * INDENT_SIZE}px`
                                };
                            }
                            return {
                                style: `margin-inline-start: ${attributes.indentation * INDENT_SIZE}px`
                            };
                        }
                    }
                }
            }
        ];
    },
    addCommands () {
        const setNodeIndentMarkup = (tr, pos, delta, type)=>{
            var _tr_doc;
            const node = tr === null || tr === void 0 ? void 0 : (_tr_doc = tr.doc) === null || _tr_doc === void 0 ? void 0 : _tr_doc.nodeAt(pos);
            if (node) {
                const nextLevel = (node.attrs.indentation || 0) + delta;
                const indent = nextLevel < minLevel ? minLevel : nextLevel > maxLevel ? maxLevel : nextLevel;
                if (indent !== node.attrs.indentation) {
                    const _node_attrs = node.attrs, { indentation: _ } = _node_attrs, currentAttrs = _object_without_properties(_node_attrs, [
                        "indentation"
                    ]);
                    const nodeAttrs = indent > minLevel ? _object_spread_props(_object_spread({}, currentAttrs), {
                        indentation: indent,
                        indentType: type
                    }) : currentAttrs;
                    return tr.setNodeMarkup(pos, node.type, nodeAttrs, node.marks);
                }
            }
            return tr;
        };
        const updateIndentationLevel = (tr, delta, type)=>{
            const { doc, selection } = tr;
            if (doc && selection && isTextSelection(selection)) {
                const { from, to } = selection;
                doc.nodesBetween(from, to, (node, pos)=>{
                    if (typesThatCanBeIndented.includes(node.type.name)) {
                        setNodeIndentMarkup(tr, pos, delta, type);
                        return false;
                    }
                    return true;
                });
            }
            return tr;
        };
        return {
            applyIndentation: (direction, type)=>({ tr, state, dispatch })=>{
                    const { selection } = state;
                    tr.setSelection(selection);
                    updateIndentationLevel(tr, direction, type);
                    if (tr.docChanged) {
                        dispatch === null || dispatch === void 0 ? void 0 : dispatch(tr);
                        return true;
                    }
                    return false;
                },
            indent: (type)=>({ state, commands })=>{
                    if (isInsideList(state)) {
                        return false;
                    }
                    return commands.applyIndentation(1, type);
                },
            outdent: (type)=>({ state, commands })=>{
                    if (isInsideList(state)) {
                        return false;
                    }
                    return commands.applyIndentation(-1, type);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            Tab: ()=>this.options.captureTab && this.editor.commands.indent('line'),
            'Shift-Tab': ()=>this.options.captureTab && this.editor.commands.outdent('line')
        };
    }
});

//# sourceMappingURL=indent.js.map